customElements.define('expandable-container', class ExpandableText extends HTMLElement {
  constructor() {
    super();
    this.expanded = false;
  }

  connectedCallback() {
    // Read height from attribute or use default
    this.maxHeight = this.getAttribute("max-height") || "267px";
    this.mobileWidth = this.getAttribute("mobile-width") || 1024;


    // Set initial structure inside Light DOM (not Shadow DOM)
    this.innerHTML = `
      <div class="text-wrapper">
        <div class="text-content">
          ${this.innerHTML} <!-- Pass the original content inside the component -->
        </div>
        <div class="gradient-overlay"></div>
      </div>

      <div class="btn btn--secondary btn--full expand-button" aria-expanded="false">
        <span class="button-text">Näytä lisää</span>
        <span class="chevron-icon">
          <svg 
            role="presentation" 
            aria-hidden="true" 
            xmlns="http://www.w3.org/2000/svg" 
            width="24" 
            height="24" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="currentColor" 
            stroke-width="2" 
            stroke-linecap="round" 
            stroke-linejoin="round" 
            class="feather feather-chevron-down"
          >
            <polyline points="6 9 12 15 18 9"></polyline>
          </svg>
        </span>
      </div>
    `;

    this.textWrapper = this.querySelector(".text-wrapper");
    this.gradient = this.querySelector(".gradient-overlay");
    this.toggleButton = this.querySelector(".expand-button");
    this.buttonText = this.querySelector(".button-text");
    this.chevronIcon = this.querySelector(".chevron-icon");

    this.toggleButton.addEventListener("click", () => this.toggleText());
    window.addEventListener("resize", () => this.handleResize());

    this.handleResize(); // Run on load
  }

  disconnectedCallback() {
    window.removeEventListener("resize", () => this.handleResize());
  }

  checkTextOverflow() {
    if (window.innerWidth <= this.mobileWidth) {
      this.toggleButton.style.display = "flex"; // Show button
      this.gradient.style.display = "block"; // Show gradient
    } else {
      this.toggleButton.style.display = "none"; // Hide button
      this.gradient.style.display = "none"; // Hide gradient
    }

    this.adjustWrapperHeight()
  }

  toggleText() {
    this.expanded = !this.expanded;
    this.toggleButton.setAttribute("aria-expanded", this.expanded);
    
    this.gradient.style.opacity = this.expanded ? "0" : "1";
    this.buttonText.textContent = this.expanded ? "Näytä vähemmän" : "Näytä lisää";
    // Rotate icon
    this.chevronIcon.style.transform = this.expanded ? "rotate(180deg)" : "rotate(0deg)";

    this.adjustWrapperHeight()
  }

  handleResize() {
    this.checkTextOverflow();
  }

  adjustWrapperHeight() {
    if (this.expanded) {
      this.textWrapper.style.maxHeight = this.textWrapper.scrollHeight + "px"; // Use actual content height
    } else {
      this.textWrapper.style.maxHeight = window.innerWidth <= this.mobileWidth ? this.maxHeight : 'none';
    }
  }
})